import React, { Component } from 'react';
import { Card, Col, message, Row } from 'antd';

import { queryFinanceBooksStatistics } from '@api/finance/finance';
import util from '@util';

class FinanceCapitalDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statistics: {},
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { uuid } = this.props;
    this.loadStatistics(uuid);
  }

  /**
   * 获取账号统计
   */
  loadStatistics = uuid => {
    queryFinanceBooksStatistics({ uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({ statistics: res.data });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { statistics } = this.state;
    return (
      <Card className="description" style={{ paddingTop: '46px' }}>
        <Row type="flex" justify="space-around" align="middle">
          <Col span={12}>
            <p>
              <span className="title">账户名称:</span> <span>{statistics.accountName}</span>
            </p>
            <p>
              <span className="title">账面科目:</span> <span>{statistics.companyName}</span>
            </p>
            <p>
              <span className="title">所在部门:</span> <span>{statistics.accountName}</span>
            </p>
            <p>
              <span className="title">付款金额:</span> <span>{statistics.companyName}</span>
            </p>
          </Col>
          <Col span={12}>
            <p>
              <span className="title">付款单号:</span>
              <span>{util.numberFormat(statistics.incomeSum, 2, '.', ',')}</span>
            </p>
            <p>
              <span className="title">申请时间:</span>
              <span>{util.numberFormat(statistics.expenditureSum, 2, '.', ',')}</span>
            </p>
            <p>
              <span className="title">所在公司:</span>
              <span>{util.numberFormat(statistics.expenditureSum, 2, '.', ',')}</span>
            </p>
            <p>
              <span className="title">付款公司:</span>
              <span>{util.numberFormat(statistics.expenditureSum, 2, '.', ',')}</span>
            </p>
          </Col>
        </Row>
        <Row type="flex" justify="space-around" align="middle">
          <Col span={24}>
            <p>
              <span className="title">分摊方案:</span> <span>{statistics.accountName}</span>
            </p>
          </Col>
        </Row>
        <Row type="flex" justify="space-around" align="middle">
          <Col span={12}>
            <p>
              <span className="title">收款方:</span> <span>{statistics.accountName}</span>
            </p>
          </Col>
          <Col span={12}>
            <p>
              <span className="title">发票编号:</span>
              <span>{util.numberFormat(statistics.incomeSum, 2, '.', ',')}</span>
            </p>
          </Col>
        </Row>
        <Row type="flex" justify="space-around" align="middle">
          <Col span={24}>
            <p>
              <span className="title">付款凭证:</span> <span>{statistics.accountName}</span>
            </p>
          </Col>
        </Row>
        <Row type="flex" justify="space-around" align="middle">
          <Col span={24}>
            <p>
              <span className="title">付款说明:</span> <span>{statistics.accountName}</span>
            </p>
          </Col>
        </Row>
      </Card>
    );
  }
}

export default FinanceCapitalDetail;



// WEBPACK FOOTER //
// ./src/components/finance/budget/check/CardStatic.js